import { RefundModel } from 'api-hooks/refund/refund';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { CardSection, FullContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import ProductVariantTable from './product-variant';
import { FormType } from '../../form-type';
interface Props {
  refund?: RefundModel;
}

export default function ProductSaleSection(props: Props) {
  const { control } = useFormContext<FormType>();
  const name = 'productSales';
  const { fields } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const { t } = useTranslation();

  if (fields.length === 0) {
    return null;
  }

  return (
    <>
      {fields.map((field, index) => {
        if (index !== 0) return null;
        return (
          <React.Fragment key={field.customId}>
            <Separator gap={24} />
            <CardSection>
              <FullContainer>
                <Text variant="HeadingXSmall">
                  {t('common:product_details')}
                </Text>
              </FullContainer>
              <Separator gap={24} />
              <ProductVariantTable refund={props.refund} />
            </CardSection>
          </React.Fragment>
        );
      })}
    </>
  );
}
